import { NgModule } from '@angular/core';
import { GtmGgCartUpdateEntrySuccessEventBuilder } from './gtm-gg-cart-update-entry-success-event.builder';

@NgModule({})
export class GtmGgCartUpdateEntrySuccessEventModule {
  constructor(_gtmGgCartUpdateEntrySuccessEventBuilder: GtmGgCartUpdateEntrySuccessEventBuilder) {}
}
